import { IDeleteHospitalAction } from './deleteHospital.interface';

export enum DeleteHospitalTypes {
	DELETE_HOSPITAL = 'DELETE_HOSPITAL',
}

export type DeleteHospitalAction = IDeleteHospitalAction;
